import { render, staticRenderFns } from "./switchItemStyle.vue?vue&type=template&id=7874c76b&scoped=true"
import script from "./switchItemStyle.vue?vue&type=script&lang=js"
export * from "./switchItemStyle.vue?vue&type=script&lang=js"
import style0 from "./switchItemStyle.vue?vue&type=style&index=0&id=7874c76b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7874c76b",
  null
  
)

export default component.exports